var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"questions__steps"},_vm._l((_vm.bulletsProp),function(mode,index){return _c('li',{key:index + mode.status,staticClass:"question__step"},[_c('Bullet',{attrs:{"mode":mode.status}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }